/* Contract for support request submission */
export class SupportRequestContract
{
	comments: string | undefined;
	supportCategoryDomainId: string | undefined;
	webBrowser: string | undefined;
	emailAddress: string | undefined;
	phoneNumber: string | undefined;
	contactMethodDomainId: string | undefined;
	agentId: string | undefined;
	policyDisplayNumber: string | undefined;
	name: string | undefined;
	userName: string | undefined;
}